import { Star, Quote, ExternalLink } from "lucide-react";
import { SectionHeading, Reveal } from "./shared";

const GOOGLE_URL = "https://share.google/bwjZWYnZZpkXLjOAc";

const THEMES = [
  {
    title: "Aparelho como novo",
    text: "Clientes relatam que o celular voltou funcionando como novo depois do reparo na Pressi.",
  },
  {
    title: "Atendimento ágil e cordial",
    text: "A rapidez e o trato amigável da equipe são os elogios mais repetidos nas avaliações.",
  },
  {
    title: "Confiança que vale a viagem",
    text: "Tem cliente que sai de Porto Alegre e de outras cidades da região só para consertar na Pressi.",
  },
];

const Stars = ({ size = 16 }) => (
  <div className="flex gap-0.5" aria-label="Avaliação 5 de 5">
    {Array.from({ length: 5 }).map((_, s) => (
      <Star key={s} size={size} className="fill-[#ADCF5D] text-[#ADCF5D]" />
    ))}
  </div>
);

export default function Testimonials() {
  return (
    <section id="avaliacoes" className="relative py-24 sm:py-32 px-4 sm:px-8 bg-[#293138]">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          overline="/// Avaliações do Google"
          title="QUEM CONFIA NA PRESSI, RECOMENDA"
        />

        <Reveal delay={0.05} className="mt-12">
          <div
            data-testid="google-rating-card"
            className="rounded-2xl border border-[#99BA4B]/40 bg-[#2E373E] p-8 flex flex-col sm:flex-row items-center justify-between gap-6"
          >
            <div className="flex items-center gap-6">
              <span className="font-display text-6xl text-white">5,0</span>
              <div>
                <Stars size={20} />
                <p className="mt-2 text-sm text-zinc-300">
                  Nota máxima no Google
                </p>
                <p className="font-mono-tech text-xs text-zinc-400 mt-1">
                  113 avaliações de clientes reais
                </p>
              </div>
            </div>
            <a
              data-testid="google-reviews-link"
              href={GOOGLE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#99BA4B] hover:bg-[#ADCF5D] text-[#1D2328] font-bold text-sm px-6 py-3.5 rounded-full transition-all duration-150 active:scale-95"
            >
              <ExternalLink size={16} />
              Ver avaliações no Google
            </a>
          </div>
        </Reveal>

        <div className="mt-6 grid md:grid-cols-3 gap-5">
          {THEMES.map((t, i) => (
            <Reveal key={t.title} delay={0.1 + i * 0.08}>
              <figure
                data-testid={`testimonial-card-${i + 1}`}
                className="h-full rounded-2xl border border-white/10 bg-[#2E373E] p-6 flex flex-col hover:border-[#99BA4B]/50 hover:-translate-y-1 transition-all duration-300"
              >
                <Quote size={22} className="text-[#99BA4B]/70" />
                <blockquote className="mt-4 text-sm leading-relaxed text-zinc-200 flex-1">
                  {t.text}
                </blockquote>
                <figcaption className="mt-6 pt-5 border-t border-white/10 flex items-center justify-between">
                  <div>
                    <p className="font-display text-white text-sm">{t.title}</p>
                    <p className="font-mono-tech text-[11px] text-zinc-400 mt-1">
                      Resumo de avaliações do Google
                    </p>
                  </div>
                  <Stars size={13} />
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
